import { MainApi } from "./MainApi";
import { PaymentDTO } from "../types/payment";

export class PaymentApi {
  static baseUrl = `${MainApi.urlPrefix}/payments`;

  static getPayment = (orderIdx: number) => () =>
    MainApi.api.get<PaymentDTO>(`${PaymentApi.baseUrl}${MainApi.toParamStringFromObject({ orderIdx })}`);
}
